var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5833 46.3333H49.2917L48.125 45.2083C52.2083 40.4583 54.6667 34.2917 54.6667 27.5833C54.6667 12.625 42.5417 0.5 27.5833 0.5C12.625 0.5 0.5 12.625 0.5 27.5833C0.5 42.5417 12.625 54.6667 27.5833 54.6667C34.2917 54.6667 40.4583 52.2083 45.2083 48.125L46.3333 49.2917V52.5833L67.1667 73.375L73.375 67.1667L52.5833 46.3333ZM27.5833 46.3333C17.2083 46.3333 8.83333 37.9583 8.83333 27.5833C8.83333 17.2083 17.2083 8.83333 27.5833 8.83333C37.9583 8.83333 46.3333 17.2083 46.3333 27.5833C46.3333 37.9583 37.9583 46.3333 27.5833 46.3333Z",
    fill: "#8F191C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.bc466b9e6934c4bcd6d3be0b5abd156f.svg";
export { ForwardRef as ReactComponent };